import BaseComponent from 'scripts/BaseComponent.js';
import Cart from '../cart';

export default class CartFooterProduct extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = true;

    this.refs = {
      priceTotal: '.js-priceTotal',
      minusQtyBtn: '.js-minusQtyBtn',
      addQtyBtn: '.js-addQtyBtn',
      qtyAmount: '.js-qtyAmount',
      addItemBtn: '.js-cartFooterAddBtn',
    };

    this.dom = {
      $component: component,
      $priceTotal: this.$get(this.refs.priceTotal),
      $minusQtyBtn: this.$get(this.refs.minusQtyBtn),
      $addQtyBtn: this.$get(this.refs.addQtyBtn),
      $qtyAmount: this.$get(this.refs.qtyAmount),
      $addItemBtn: this.$get(this.refs.addItemBtn),
    };

    this.state = {};

    this.mount();
  }

  mount() {
    super.mount();

    this.init();
  }

  init() {
    const { dom } = this;

    this.setClick(dom.$minusQtyBtn, this.minusQty);
    this.setClick(dom.$addQtyBtn, this.addQty);
    this.setClick(dom.$addItemBtn, this.addToCart);
  }

  addQty() {
    const { dom } = this;
    const money = new Intl.NumberFormat('en-us', { style: 'currency', currency: 'USD', trailingZeroDisplay: 'stripIfInteger' });
    const { variantPrice } = dom.$component.dataset;
    let qty = parseInt(dom.$qtyAmount.innerText, 10);

    if (qty < 99) {
      qty += 1;
      dom.$qtyAmount.innerText = qty;
      dom.$priceTotal.innerText = money.format((variantPrice * qty));
    }
  }

  minusQty() {
    const { dom } = this;
    const money = new Intl.NumberFormat('en-us', { style: 'currency', currency: 'USD', trailingZeroDisplay: 'stripIfInteger' });
    const { variantPrice } = dom.$component.dataset;
    let qty = parseInt(dom.$qtyAmount.innerText, 10);

    if (qty > 1) {
      qty -= 1;
      dom.$qtyAmount.innerText = qty;
      dom.$priceTotal.innerText = money.format((variantPrice * qty));
    }
  }

  addToCart() {
    const { dom } = this;
    const { variantId } = dom.$component.dataset;
    const qty = parseInt(dom.$qtyAmount.innerText, 10);

    Cart.addItem(variantId, {}, qty, false);
  }
}
